import { render, staticRenderFns } from "./Item-popup.vue?vue&type=template&id=60176d36&scoped=true&lang=pug"
import script from "./Item-popup.vue?vue&type=script&lang=js"
export * from "./Item-popup.vue?vue&type=script&lang=js"
import style0 from "./Item-popup.vue?vue&type=style&index=0&id=60176d36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60176d36",
  null
  
)

export default component.exports